<template>
    
</template>

<script>
    export default {
        name: "ComponentTemplatesMixin",
        methods: {
            emitAction (actionName,payload) {
                this.$emit(actionName,payload);
            },
            $t (val) {
                return window.LWTranslate.get(val);
            },
        }
    }
</script>

